/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Static enums extracted from: @tencent/tpro_rmonitor_product_manager_productoa
 * DO NOT EDIT MANUALLY — run "npm run gen:proto-enums" to regenerate.
 *
 * Zero dependencies — only static enum definitions.
 * Supports nested namespace access: enumTrpc.rmonitor.web_server.IssueType
 */

export namespace enumTrpc {
  export namespace rmonitor {
    export namespace product_manager {
      export enum PlatformType {
        UNKNOWN_PLATFORM = 0,
        ANDROID = 1,
        IPHONE = 2,
        MAC = 4,
        LINUX = 5,
        FLUTTER = 9,
        WINDOWS = 10,
        HARMONY = 11,
        Hippy = 14,
        Kuikly = 15,
        VisionOS = 17,
        MiniProgram = 18,
        Electron = 19,
        AppleTV = 20,
        ReactNative = 21,
      }

    }

  }

}
